import React from "react";
import logo from "./assets/logo_kairos_black.png";

export default function Home({ onStartL1, onStartL3, onPreIntake }) {
  return (
    <div style={styles.wrapper}>

      <div
  style={styles.logoWrapper}
  onClick={() => (window.location.href = "/")}
  onMouseEnter={(e) => (e.currentTarget.firstChild.style.opacity = "0.6")}
  onMouseLeave={(e) => (e.currentTarget.firstChild.style.opacity = "1")}
>
  <img
    src={logo}
    alt="Kairos Logo"
    style={{ ...styles.logo, cursor: "pointer", transition: "opacity 0.25s ease" }}
  />
</div>

     {/* CONTENT CENTERED */}
<div style={styles.centerBox}>

  <h1 style={styles.title}>
    Proof of Concept
    <br />
    <span style={styles.titleSecond}>The Kairos Method</span>
  </h1>

  <p style={styles.subtitle}>Two levels. One architecture. One method.</p>

  <p style={styles.desc} className="home-paragraph">
    This PoC demonstrates Level 1 (Gentle Mode) and Level 3 (Advanced Vertical Cut), both built on calibrated questions and controlled intensity.
  </p>

        <div style={styles.buttons}>
          <button style={styles.btn} onClick={onStartL1}>
            Level 1 | Gentle Mode
          </button>

          <button style={styles.btn} onClick={onStartL3}>
  Level 3 | Advanced Mode 
</button>

<button style={styles.subBtn} onClick={onPreIntake}>
  PreIntake Filter (for Level 3)
</button>
        </div>
      </div>

    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background: "#fff",
  },

  logoWrapper: {
    position: "fixed",
    top: 30,
    left: 30,
    zIndex: 1000,
  },

  logo: {
    height: 48,
  },

  centerBox: {
    textAlign: "Left",
    width: "90%",
    maxWidth: 700,
    marginTop: 10,
  },

  title: {
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: "0.2px",
    marginBottom: -20,
    fontFamily: "Carlito, sans-serif",
    whiteSpace: "nowrap",
  },

  titleSecond: {
    fontSize: 48,
    fontWeight: 400,
    letterSpacing: "0.2px",
    fontFamily: "Carlito, sans-serif",
  },

  subtitle: {
    fontSize: 24,
    fontWeight: 400,
    letterSpacing: "0.2px",
    color: "#222",
    marginBottom: 20,
  },

  desc: {
  fontSize: 15,
  color: "#333",
  maxWidth: 600,
  margin: "0 auto 30px",
  lineHeight: 1.55,
  textAlign: "left",    
},

  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "left",
  },

  btn: {
    padding: "10px 18px",
    borderRadius: "9999px",
    border: "1px solid #ffffffff",
    background: "#222",
    color: "#fff",
    fontSize: 14,
    cursor: "pointer",
    width: 230,
    fontFamily: "Carlito, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.3px",
  },

  subBtn: {
    padding: "10px 18px",
    borderRadius: "9999px",
    border: "1px solid #222",
    background: "#ffffffff",
    color: "#222",
    fontSize: 13,
    cursor: "pointer",
    width: 200,
    marginTop: 10,
    fontFamily: "Carlito, sans-serif",
    fontWeight: 600,
    letterSpacing: "0.3px",
  },
};

